<template>
  <nuttrema-layout-form-standard
     theme="west-top"
    :edit="true"
    :saveError="StuffToEatExchange.saveError">

    <template slot="center">
        <el-form
           label-width="8em"
           label-position="right"
          :rules="rules"
          :ref="formRef"
          :model="formData">

          <section>
            <h4 class="section-title">
              {{ $t(exchangeTitle) }}
            </h4>
            <div class="section-items">
              <stuff-to-eat-info-small-card
                 slot="left"
                :reactive="false"
                :details="_get(StuffToEatMainDetails, 'data')">
              </stuff-to-eat-info-small-card>
              <hr>
              <el-form-item :label="$t('label.amount')" prop="entity_amount" class="el-form-item--east-validation-inline">
                <el-col :span="12">
                  <el-input-number
                    class="w-100"
                    v-model="formData.entity_amount"
                    @change="calculateTotalGr('entity', StuffToEatMainDetails, 'entity_amount', 'entity_serving_size_id')">
                  </el-input-number>
                </el-col>
              </el-form-item>
              <el-form-item :label="$t('label.serving_size')" prop="entity_serving_size_id" class="el-form-item--east-validation-inline">
                <el-col :span="24">
                  <el-select
                    class="w-100"
                    v-model="formData.entity_serving_size_id"
                    @change="calculateTotalGr('entity', StuffToEatMainDetails, 'entity_amount', 'entity_serving_size_id')">
                    <el-option-group
                       v-for="servingGroup in filterList(StuffToEatMainDetails, 'data.EntityServingSizes.available_serving')"
                      :label="servingGroup.title"
                      :key="servingGroup.key">
                      <el-option
                        v-for="item in servingGroup.list"
                        :label="`${item.title} (${item.weight_gr}g)`"
                        :key="item.id"
                        :value="item.id">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item :label="$t('label.weight')">
                <el-col :span="12" class="el-col--total">
                  <span>{{ totalGr.entity | number-format(2) }}</span>g
                </el-col>
              </el-form-item>
            </div>
          </section>

          <section>
            <h4 class="section-title">
              {{ $t('label.exchange') }}
            </h4>
            <div class="section-items">
              <stuff-to-eat-info-small-card
                 slot="left"
                :reactive="false"
                :details="_get(StuffToEatExchangeDetails, 'data')">
              </stuff-to-eat-info-small-card>
              <hr>
              <el-form-item :label="$t('label.amount')" prop="exchange_amount" class="el-form-item--east-validation-inline">
                <el-col :span="12">
                  <el-input-number
                    class="w-100"
                    v-model="formData.exchange_amount"
                    @change="calculateTotalGr('exchange', StuffToEatExchangeDetails, 'exchange_amount', 'exchange_serving_size_id')">
                  </el-input-number>
                </el-col>
              </el-form-item>
              <el-form-item :label="$t('label.serving_size')" prop="exchange_serving_size_id" class="el-form-item--east-validation-inline">
                <el-col :span="24">
                  <el-select
                    class="w-100"
                    v-model="formData.exchange_serving_size_id"
                    @change="calculateTotalGr('exchange', StuffToEatExchangeDetails, 'exchange_amount', 'exchange_serving_size_id')">
                    <el-option-group
                       v-for="servingGroup in filterList(StuffToEatExchangeDetails, 'data.EntityServingSizes.available_serving')"
                      :label="servingGroup.title"
                      :key="servingGroup.key">
                      <el-option
                        v-for="item in servingGroup.list"
                        :label="`${item.title} (${item.weight_gr}g)`"
                        :key="item.id"
                        :value="item.id">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item :label="$t('label.weight')">
                <el-col :span="12" class="el-col--total">
                  <span>{{ totalGr.exchange | number-format(2) }}</span>g
                </el-col>
              </el-form-item>
            </div>
          </section>
        </el-form>
    </template>
    <!-- end ~ slot - center -->

    <template slot="footer" v-if="entityExchangeID !== -1">
      <div class="footer-row">
        <div class="footer-row__column">
          <el-button
             type="primary"
             size="small"
            :loading="isSaving"
            :disabled="!isDataChanged"
            @click="submitForm">
            {{ $t('label.save_changes') }}
          </el-button>
          <el-button type="text" size="small" @click="cancelChanges">{{ $t('label.cancel') }}</el-button>
        </div>

        <div class="footer-row__column">
          <popover-question-alert
             slot="bottom-right"
             buttonTitle="label.delete"
             buttonType="danger"
             popoverWidth="280"
             popoverTitle="label.delete"
             popoverText="label.delete_sure"
             popoverPlacement="top-end"
             buttonSize="small"
            :popoverShouldShow="true"
            @confirmed="handleDelete">
          </popover-question-alert>
        </div>
      </div>
    </template>

    <template v-else slot="footer">
      <div class="footer-row">
        <el-button
           type="primary"
           size="small"
          :loading="isSaving"
          :disabled="!isDataChanged"
          @click="submitForm">
          {{ $t('label.add_new') }}
        </el-button>

        <el-button
          size="small"
          type="text"
          @click="cancelChanges">
          {{ $t('label.cancel') }}
        </el-button>
      </div>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import { isEmpty, isNil, get, filter, find, each } from 'lodash';

import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import PopoverQuestionAlert from 'components/ui/alert/nuttrema-popover-question-alert';

import StuffToEatInfoSmallCard from 'components/ui/card/stuff-to-eat-info-small-card';

export default {
  name: 'form-stuff-to-eat-cred-exchange',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    id: {
      required: true,
      default: null,
    },
    exchangeID: {
      required: true,
      default: null,
    },
    entityExchangeID: {
      required: false,
      default: null,
    },
    productType: {
      required: true,
      default: null,
    },
    exchangeTitle: {
      required: true,
      default: null,
    },
    StuffToEatMainDetails: {
      type: Object,
      required: true,
      default: null,
    },
    StuffToEatExchangeDetails: {
      type: Object,
      required: true,
      default: null,
    },
    StuffToEatExchange: {
      type: Object,
      required: false,
      default: null,
    },
  },
  components: {
    PopoverQuestionAlert,
    StuffToEatInfoSmallCard,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      totalGr: {
        entity: null,
        exchange: null,
      },
      formData: {
        exchange_id: null,
        entity_amount: 1,
        entity_serving_size_id: null,
        exchange_amount: 1,
        exchange_serving_size_id: null,
      },
      rules: {
        entity_amount: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.amount', true),
          },
        ],
        exchange_amount: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.amount', true),
          },
        ],
        entity_serving_size_id: [
          {
            required: true,
            trigger: 'change',
            message: this.formatValidationMessage('validation.required', 'label.serving_size', true),
          },
        ],
        exchange_serving_size_id: [
          {
            required: true,
            trigger: 'change',
            message: this.formatValidationMessage('validation.required', 'label.serving_size', true),
          },
        ],
      },
    };
  },
  methods: {
    getFormData() {
      return this.removeEmpty(this.formData);
    },
    setFormData() {
      this.formData.exchange_id = this.exchangeID !== -1 ? this.exchangeID : null;

      this.formData.entity_amount = get(this.StuffToEatExchange, 'data.entity_amount', 1);
      this.formData.entity_serving_size_id = get(this.StuffToEatExchange, 'data.entity_serving_size_id', null);
      this.formData.exchange_amount = get(this.StuffToEatExchange, 'data.exchange_amount', 1);
      this.formData.exchange_serving_size_id = get(this.StuffToEatExchange, 'data.exchange_serving_size_id', null);

      this.calculateTotalGr('entity', this.StuffToEatMainDetails, 'entity_amount', 'entity_serving_size_id');
      this.calculateTotalGr('exchange', this.StuffToEatExchangeDetails, 'exchange_amount', 'exchange_serving_size_id');
    },
    filterList(data, key) {
      const list = get(data, key, []);
      return filter(list, item => !isEmpty(item.list));
    },
    calculateTotalGr(type, data, entityAmount, servingSizeID) {
      this.$nextTick(() => {
        let found = null;
        if (isNil(this.formData[servingSizeID])) return 0;
        const list = get(data, 'data.EntityServingSizes.available_serving', []);
        const flatten = JSON.parse(JSON.stringify(list));
        each(flatten, (serving) => {
          const tmp = find(serving.list, item => item.id === this.formData[servingSizeID]);
          if (tmp) found = tmp;
        });
        this.totalGr[type] = found ? this.formData[entityAmount] * found.weight_gr : 0;
        return 0;
      });
    },
  },
  created() {
    this.setFormData();
    this.stateData = this.StuffToEatExchange;
    this.formRef = 'form-stuff-to-eat-cred-exchange';
  },
};
</script>

<style lang="scss" scoped>
  .el-col--unit {
    line-height: 2.5em;
    padding: 0 0.75em;
  }
  .el-col--total {
    span {
      line-height: 2.5em;
      font-weight: 500;
    }
  }
  hr {
    margin: 0.75rem 0;
  }

  /deep/ .el-form {
    .el-form-item .el-form-item__label {
      line-height: 40px !important;
    }
    .el-form-item .el-form-item__error {
      margin: 0 !important;
      position: absolute !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/exchanges/form-stuff-to-eat-cred-exchange.vue